export const PhiAuthCommsPreferencesText =
  'We message you medication and order updates. Can we include health information (like medication names) in push notifications, text messages, and emails?';
export const PhiAuthCommsPreferencesTextWithoutPush =
  'We message you medication and order updates. Can we include health information (like medication names) in text messages and emails?';
